(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
      $( window ).resize(function() {
      var screen = $( window ).width();
      if(screen < 768) {
      $(".collection_description_left p:not(:first-child)").appendTo('.collectios-description-bottom');
      
                      }
       if(screen >= 768) {
      $(".collectios-description-bottom p").appendTo('.collection_description_left');
       }
      });
    $(document).ready(function() {
      var screen = $( window ).width();
      if(screen < 768) {
     $(".collection_description_left p:not(:first-child)").appendTo('.collectios-description-bottom');
      
                      }
      });
        
      
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
      $(document).ready(function() { 
  $(window).load(function() { 
      $('.spr-content .spr-form .new-review-form .spr-form-title').prependTo('.spr-summary span.spr-summary-actions');
      $('.STP-tier-block .STP-tier-block-lines').prepend('QTY  &nbsp;&nbsp;&nbsp;&nbsp;   Price &nbsp;&nbsp;&nbsp;&nbsp; SAVE<br>');
      $('.fast-free-delivery .STP-tier-block').append('<h5>Discount applied at checkout</h5>');
      if($( ".fast-free-delivery div" ).hasClass( "STP-tiers" )){
     var lines = $(".STP-tier-block-lines").html().split("<br>");
		$(".STP-tier-block-lines").html('<p>' + lines.join("</p><p>") + '</p>');
      }
      
      $('.color-swatches .color-swatches-list').html($('.bottom-description-outer ul.color-options').html());
      
             $(".color-swatches .color-swatches-list li").each(function(index) {
			
            $(this).css('background-color',$(this).find('a').text());
           
            $(this).find('a').text('');
      
      			if($(this).attr('data-value') != ''){
      				$(this).css('background-color',$(this).attr('data-value'));
      				$(this).attr('background-color',$(this).attr('data-value'));
      			}
            });
      
      });
      
      });
      
  } catch(e) { console.error(e); }
})();
      })();
